import React from "react";
import { Btn, Card, Input, Overline } from "../../../ForBrands/ui/BrandUI";
import { FormFieldM, MobileCard } from "../../../ForBrands/ui/mobile/MobileUI";
import { usePhoneTheme } from "../../../ForBrands/useIsPhone";

const AmountField = ({ id, label, value, onChange, onBlur }) => (
  <>
    <label htmlFor={id} className="bm-label-l text-bm-ink lg:w-[216px] lg:shrink-0">
      {label}
    </label>
    <div className="min-w-[180px] flex-1">
      <Input id={id} prefix="$" value={value} onChange={(e) => onChange(e.target.value)} onBlur={onBlur} placeholder="0.00" inputMode="decimal" />
    </div>
  </>
);

// Phone amount (FormField · Mobile, 2415:1573): the label over a 56px field
// with the "$" in front. 16px text, so iOS does not zoom into it (D-g6).
const PhoneAmountField = ({ id, label, value, onChange, onBlur }) => (
  <FormFieldM label={label} htmlFor={id}>
    <span className="flex h-14 items-center gap-[6px] rounded-[12px] border border-bm-border bg-white px-[18px] focus-within:border-bm-ink focus-within:ring-1 focus-within:ring-inset focus-within:ring-bm-ink">
      <span className="text-[16px] leading-[22px] text-bm-ink">$</span>
      <input
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={onBlur}
        placeholder="0.00"
        inputMode="decimal"
        className="bm-bare min-w-0 flex-1 bg-transparent text-[16px] leading-[22px] text-bm-ink outline-none placeholder:text-bm-placeholder"
      />
    </span>
  </FormFieldM>
);

const FIELDS = [
  { id: "cs-revenue-share", pool: "rs", label: "Total amount for revenue share" },
  { id: "cs-nil", pool: "nil", label: "Total amount for NIL distribution" },
];

// Figma 03b · Budget: one amount per pool (revenue share and NIL), both
// starting at $0.00, then Distribute. On phones (2415:1573) the card has no
// overline, the fields stack, and Distribute is a full-width 52px button.
const BudgetCard = ({ amounts, onAmount, onSettle, onDistribute, canDistribute, distributing }) => {
  const phone = usePhoneTheme();
  const distribute = (
    <Btn size={phone ? "lg" : undefined} className={phone ? "w-full" : undefined} onClick={onDistribute} disabled={!canDistribute || distributing}>
      {distributing ? "Distributing..." : "Distribute"}
    </Btn>
  );
  if (phone) {
    return (
      <MobileCard className="!gap-[14px]">
        {FIELDS.map((f) => (
          <PhoneAmountField key={f.id} id={f.id} label={f.label} value={amounts[f.pool]} onChange={(v) => onAmount(f.pool, v)} onBlur={() => onSettle(f.pool)} />
        ))}
        {distribute}
      </MobileCard>
    );
  }
  return (
    <Card padding="px-5 py-4" className="flex flex-col gap-3">
      <Overline>Budget</Overline>
      <div className="flex flex-wrap items-center gap-4">
        {FIELDS.map((f) => (
          <AmountField key={f.id} id={f.id} label={f.label} value={amounts[f.pool]} onChange={(v) => onAmount(f.pool, v)} onBlur={() => onSettle(f.pool)} />
        ))}
        {distribute}
      </div>
    </Card>
  );
};

export default BudgetCard;
